import { Injectable } from '@angular/core';
import { LocalMinimumOrderRule } from '@asm/features/quick-order/models/offline-reference-data.model';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';

@Injectable({ providedIn: 'root' })
export class MinimumOrderRuleRepository extends RepositoryBase<LocalMinimumOrderRule> {
  protected readonly KEY_PATH = 'minimum_order_rules';
}
